<template>
    <transition name="fade">
        <div class="modal fade" id="modalGovID" tabindex="-1" role="dialog" data-backdrop="static" data-keyboard="false">
            <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Update Government ID</h5>
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label>Goverment Issued I.D.<span class="danger fs-18 bold">&nbsp;*</span></label>
                                    <v-select label="id_name" :options="ref_gov_id" :reduce="id_name => id_name.id_code" :clearable="false" v-model="formGovID.id_code" :class="{ 'is-invalid': submitting && $v.formGovID.id_code.$error }">
                                    </v-select>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label>I.D. Number<span class="danger fs-18 bold">&nbsp;*</span></label>
                                    <input type="text" class="form-control form-control-sm" v-model="formGovID.id_number" :class="{ 'is-invalid': submitting && $v.formGovID.id_number.$error }">
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-sm-12">
                                <div class="alert alert-info2 text-justify">
                                    <i class="fas fa-info-circle mr-1 fs-15"></i><strong>Note: </strong>
                                    <span class="text-justify fs-15">Only accepts <b>png, jpg, jpeg file format</b>. If you’re using a computer or a laptop, you may only upload an existing photo. If you’re using your mobile phone/tablet/IPAD, you may either upload an existing photo or capture a new photo.</span>
                                </div>
                                <div class="attachment-block clearfix">
                                    <div class="text-center">
                                        <img :src="attachFile.url" class="img-fluid" style="max-height: 300px!important; min-height:250px!important;" v-if="fetchATT.ATT12 || formATT.ATT12">
                                        <img class="img-fluid" src="/images/image_placeholder.jpg" v-else>
                                        <div v-show="submitting && $v.formATT.ATT12.$error " class="danger fs-13">Required</div>
                                    </div>

                                </div>
                                <div class="text-center">

                                    <div v-if="progress.ATT12">
                                        <div class="progress">
                                            <div class="progress-bar progress-bar-striped bg-success" role="progressbar" :style="'width:'+progress.ATT12+ ';'">
                                                {{progress.ATT12}}
                                            </div>
                                        </div>
                                    </div>
                                    <label class="btn btn-sm btn-primary nowrap pointer" v-else>
                                        Browse/Capture
                                        <input type="file" hidden accept=".png, .jpg, .jpeg" @change="$emit('attachID', $event)">
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-outline-primary" data-dismiss="modal" @click="$emit('cancel')">Cancel</button>
                        <button type="button" class="btn btn-primary" @click="UpdateGovID()">Update</button>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>
<script>
    import {
        required,requiredIf
    } from 'vuelidate/lib/validators';

    export default {
        props: ['formGovID', 'fetchATT', 'formATT', 'progress', 'ref_gov_id', 'attachFile'],
        data() {
            return {
                submitting:false,
            }
        },
        validations: {
            formGovID: {
                id_code: {
                    required
                },
                id_number: {
                    required
                }
            },
            formATT: {
                ATT12: {
                    required: requiredIf(function() {
                        return !this.fetchATT.ATT12;
                    })
                },
            }
        },
        created() {},
        methods: {
            UpdateGovID() {
                this.submitting = false;
                this.submitting = true;
                this.$v.formATT.ATT12.$touch();
                this.$v.formGovID.$touch();
                if (this.$v.formATT.ATT12.$invalid || this.$v.formGovID.$invalid) {

                } else {

                    let key = 'ATT12';
                    this.$parent.$parent.payloading = true;
                    const config = {
                        headers: {
                            'content-type': 'multipart/form-data',
                            'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').content,
                        },
                        onUploadProgress: function(progressEvent) {
                            this.progress[key] = parseInt(Math.round((progressEvent.loaded * 100) / progressEvent.total)) + '%';
                        }.bind(this)
                    }
                    let formData = new FormData();
                    formData.append('borrower_id', this.formGovID.borrower_id);
                    formData.append('upload_file', this.formATT[key]);
                    formData.append('attach_code', key);
                    formData.append('id_code', this.formGovID.id_code);
                    formData.append('id_number', this.formGovID.id_number);

                    axios.post('/api/v2-post-gov-id', formData, config)
                        .then(res => {
                            let data = res.data;
                            if (res.status === 200) {
                                this.formATT.ATT12 = null;
                                this.progress.ATT12 = 0;
                                this.$parent.getAttID(2);
                                $('#modalGovID').modal('hide');
                                window.URL.revokeObjectURL(this.attachFile.url);
                                this.attachFile.url = null;
                                
                            }
                            this.$parent.$parent.payloading = false;
                        }).catch(err => {
                            this.$parent.$parent.payloading = false;
                        })

                }


            },
        },
        computed: {},
        mounted() {}
    }
</script>



<style scoped>

</style>